import { Popover as PopoverPrimitive } from "radix-ui"
import { useEffect, useState } from "react"
import { cn } from "../../lib/utils"

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}
function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  const [shouldUsePortal, setShouldUsePortal] = useState(true)

  useEffect(() => {
    const dialogExists = document.querySelector('[role="dialog"]') !== null
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setShouldUsePortal(!dialogExists)
  }, [])

  const Content = (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-(--radix-popover-trigger-width) rounded-md border border-neutrals-300 bg-popover p-4 text-popover-foreground shadow-md outline-hidden hover:text-slate-950 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:zoom-out-95",
        className
      )}
      {...props}
    />
  )
  return shouldUsePortal ? (
    <PopoverPrimitive.Portal>{Content}</PopoverPrimitive.Portal>
  ) : (
    <div>{Content}</div>
  )
}

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
